import { ElementRef } from '@angular/core';
import { ALL_HOLDINGS, EXPORT_HOLDINGS_OPTION, EXPORT_LATEST_HOLDINGS_OPTION, HOLDINGS_ALL_HOLDINGS_TABLE_HEADER_DROPDOWN_CONFIG, SAVE_AS_WATCHLIST_OPTION, } from 'SecuritiesApp/ts/constants/holdings-table.constants';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { SecuritiesService } from 'SecuritiesApp/ts/services/securities.service';
import { HoldingsTableDirective } from 'SecuritiesApp/ts/directives/holdings-table.directive';
import { formatUTCDateString, formatUTCMonthDayYear } from 'Angular/utils/date';
import { getFormatter } from 'Angular/utils/number_formatter';
import * as i0 from "@angular/core";
import * as i1 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i2 from "SecuritiesApp/ts/services/securities.service";
import * as i3 from "@angular/common";
import * as i4 from "../holdings-all-holdings-date-picker/holdings-all-holdings-date-picker.component";
import * as i5 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i6 from "../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i7 from "../../../../../../../ycharts/static/ts/features/components/dropdowns/cascading-dropdown/cascading-dropdown.component";
import * as i8 from "../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
import * as i9 from "../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i10 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i11 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i12 from "../module-upsell/module-upsell.component";
function HoldingsAllHoldingsComponent_ycn_holdings_all_holdings_date_picker_5_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-holdings-all-holdings-date-picker", 29);
    i0.ɵɵlistener("dateChangeHandler", function HoldingsAllHoldingsComponent_ycn_holdings_all_holdings_date_picker_5_Template_ycn_holdings_all_holdings_date_picker_dateChangeHandler_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.handleDateChange($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("dateOptions", ctx_r2.validHoldingDates);
} }
function HoldingsAllHoldingsComponent_div_26_tr_24_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵelement(1, "a", 47);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const holding_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", holding_r6.url, i0.ɵɵsanitizeUrl)("text", holding_r6.ticker);
} }
function HoldingsAllHoldingsComponent_div_26_tr_24_td_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const holding_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r6.ticker);
} }
function HoldingsAllHoldingsComponent_div_26_tr_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, HoldingsAllHoldingsComponent_div_26_tr_24_td_1_Template, 2, 2, "td", 41)(2, HoldingsAllHoldingsComponent_div_26_tr_24_td_2_Template, 3, 1, "td", 41);
    i0.ɵɵelementStart(3, "td")(4, "div", 42)(5, "span", 43);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(7, "td", 44);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td")(10, "div", 42)(11, "span", 45);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(13, "td", 44);
    i0.ɵɵelement(14, "strong", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "td", 44);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const holding_r6 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", holding_r6.url);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !holding_r6.url);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(holding_r6.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r6.current_weight);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(holding_r6.type);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(holding_r6.change_percent_display == null ? null : holding_r6.change_percent_display.cssClass);
    i0.ɵɵproperty("textContent", holding_r6.change_percent_display == null ? null : holding_r6.change_percent_display.value);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r6.latest_quote);
} }
function HoldingsAllHoldingsComponent_div_26_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelement(1, "ycn-module-upsell", 31);
    i0.ɵɵelementStart(2, "table", 32)(3, "thead", 33)(4, "tr", 34)(5, "th", 35);
    i0.ɵɵlistener("click", function HoldingsAllHoldingsComponent_div_26_Template_th_click_5_listener() { i0.ɵɵrestoreView(_r5); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.setTableSortProperties("ticker")); });
    i0.ɵɵelementStart(6, "span", 36);
    i0.ɵɵtext(7, "Symbol");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "th", 37);
    i0.ɵɵlistener("click", function HoldingsAllHoldingsComponent_div_26_Template_th_click_8_listener() { i0.ɵɵrestoreView(_r5); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.setTableSortProperties("name")); });
    i0.ɵɵelementStart(9, "span", 36);
    i0.ɵɵtext(10, "Name");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "th", 38);
    i0.ɵɵlistener("click", function HoldingsAllHoldingsComponent_div_26_Template_th_click_11_listener() { i0.ɵɵrestoreView(_r5); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.setTableSortProperties("current_weight")); });
    i0.ɵɵelementStart(12, "span", 36);
    i0.ɵɵtext(13, "%\u00A0Weight");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "th", 37);
    i0.ɵɵlistener("click", function HoldingsAllHoldingsComponent_div_26_Template_th_click_14_listener() { i0.ɵɵrestoreView(_r5); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.setTableSortProperties("type")); });
    i0.ɵɵelementStart(15, "span", 36);
    i0.ɵɵtext(16, "Holding Type");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(17, "th", 39);
    i0.ɵɵlistener("click", function HoldingsAllHoldingsComponent_div_26_Template_th_click_17_listener() { i0.ɵɵrestoreView(_r5); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.setTableSortProperties("change_percent")); });
    i0.ɵɵelementStart(18, "span", 36);
    i0.ɵɵtext(19, "%\u00A0Change");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(20, "th", 39);
    i0.ɵɵlistener("click", function HoldingsAllHoldingsComponent_div_26_Template_th_click_20_listener() { i0.ɵɵrestoreView(_r5); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.setTableSortProperties("latest_quote")); });
    i0.ɵɵelementStart(21, "span", 36);
    i0.ɵɵtext(22, "Price");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(23, "tbody");
    i0.ɵɵtemplate(24, HoldingsAllHoldingsComponent_div_26_tr_24_Template, 17, 9, "tr", 40);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", "All Holdings");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", ctx_r2.getSortNgClass("ticker"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r2.getSortNgClass("name"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r2.getSortNgClass("current_weight"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r2.getSortNgClass("type"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r2.getSortNgClass("change_percent"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r2.getSortNgClass("latest_quote"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r2.formattedHoldings);
} }
function HoldingsAllHoldingsComponent_div_27_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 48)(1, "div", 11)(2, "div", 12)(3, "span", 13);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 12)(6, "button", 49);
    i0.ɵɵlistener("click", function HoldingsAllHoldingsComponent_div_27_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r7); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.pageChangeHandler(ctx_r2.PAGE_CONTROLS.PREV)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(7, "svg", 15);
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(8, "div", 12)(9, "button", 49);
    i0.ɵɵlistener("click", function HoldingsAllHoldingsComponent_div_27_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r7); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.pageChangeHandler(ctx_r2.PAGE_CONTROLS.NEXT)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(10, "svg", 15);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate3(" Showing ", ctx_r2.paginationInfo.start_index, "-", ctx_r2.paginationInfo.end_index, " of ", ctx_r2.paginationInfo.num_items, " items ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r2.pageNum === 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-back");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r2.pageNum === ctx_r2.paginationInfo.num_pages);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-collapse");
} }
function HoldingsAllHoldingsComponent_ycn_loading_symbol_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 50);
} }
/* eslint-disable prefer-destructuring */
/**
 * HoldingsAllHoldingsComponent
 *
 * Displays a table containing 'all holdings' data for a fund.
 *
 */
export class HoldingsAllHoldingsComponent extends HoldingsTableDirective {
    constructor(el, featuresService, securitiesService) {
        super(featuresService, securitiesService);
        this.el = el;
        this.featuresService = featuresService;
        this.securitiesService = securitiesService;
        this.actionsDropdownConfig = HOLDINGS_ALL_HOLDINGS_TABLE_HEADER_DROPDOWN_CONFIG;
        this.USER = window.USER;
        this.securityId = el.nativeElement.getAttribute('securityId');
        this.displaySecurityId = el.nativeElement.getAttribute('displaySecurityId');
    }
    ngOnInit() {
        this.type = ALL_HOLDINGS;
        // Fetch latest holding data
        this.getHoldings();
        // Fetch valid holding dates
        this.securitiesService.getAllHoldingDates(this.securityId).subscribe((response) => {
            this.validHoldingDates = response.holding_dates.map((dateString) => new Date(dateString));
            this.currentHoldingDate = this.validHoldingDates[0];
            this.asOfDate = formatUTCMonthDayYear(this.currentHoldingDate);
        });
    }
    formatHoldings(holdings) {
        const valFormatter = getFormatter('percent');
        return holdings.map((holding) => {
            const formattedHolding = { ...holding };
            const changePercentVal = formattedHolding.change_percent;
            const currentWeight = formattedHolding.current_weight;
            if (changePercentVal !== null) {
                formattedHolding.change_percent_display = {
                    cssClass: parseFloat(changePercentVal.toString()) < 0 ? 'text-red' : 'text-green',
                    value: valFormatter(changePercentVal, 2),
                };
            }
            else {
                formattedHolding.change_percent_display = {
                    cssClass: '',
                    value: '--',
                };
            }
            formattedHolding.current_weight = currentWeight ? valFormatter(currentWeight, 2) : '--';
            formattedHolding.latest_quote = holding.latest_quote || '--';
            formattedHolding.ticker = holding.ticker || '--';
            formattedHolding.type = formattedHolding.type || '--';
            return formattedHolding;
        });
    }
    selectDropdownOption(option) {
        switch (option) {
            case EXPORT_HOLDINGS_OPTION:
                this.exportHoldingDataUrl(formatUTCDateString(this.currentHoldingDate));
                break;
            case EXPORT_LATEST_HOLDINGS_OPTION:
                this.exportHoldingDataUrl(formatUTCDateString(this.validHoldingDates[0]));
                break;
            case SAVE_AS_WATCHLIST_OPTION:
                this.saveAsWatchlist();
                break;
            default:
                break;
        }
    }
}
HoldingsAllHoldingsComponent.ɵfac = function HoldingsAllHoldingsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HoldingsAllHoldingsComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.FeatureService), i0.ɵɵdirectiveInject(i2.SecuritiesService)); };
HoldingsAllHoldingsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HoldingsAllHoldingsComponent, selectors: [["ycn-holdings-all-holdings"]], standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 39, vars: 18, consts: [["helpModal", ""], [1, "tab-pane", "active"], [1, "page-header"], [1, "page-title"], [1, "page-name"], [3, "dateOptions", "dateChangeHandler", 4, "ngIf"], [1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], ["data-test-id", "As Of Date", 1, "panel-date", 2, "line-height", "initial"], [1, "help-toggler", 3, "click"], [1, "panel-actions"], [1, "panel-action"], [1, "panel-results-count"], ["ycnDisabled", "", "data-test-id", "Prev Button", 1, "btn", "btn-secondary", 3, "click", "disabled"], ["ycnIcon", "", 3, "name"], ["ycnDisabled", "", "data-test-id", "Next Button", 1, "btn", "btn-secondary", 3, "click", "disabled"], [1, "panel-action", "dropdown"], ["buttonClass", "options-handler btn btn-xs btn-circle btn-transparent", "dropdownClass", "dropdown-menu-right dropdown-menu-with-icons", 3, "handler", "showDropdownCaret", "config"], ["class", "panel-content", "style", "min-height: 200px", 4, "ngIf"], ["class", "panel-footer panel-footer-short", 4, "ngIf"], ["loaderMessage", "Loading Data...", 4, "ngIf"], [3, "closeModalHandler", "extraModalClasses", "open"], ["header", "Save as Watchlist", 3, "closeModalHandler"], [1, "modal-body"], [1, "modal-section", "section-info", 3, "textContent"], [1, "modal-footer", "user-select-none"], [1, "modal-footer-actions"], [1, "btn", "btn-text", 3, "click"], [3, "dateChangeHandler", "dateOptions"], [1, "panel-content", 2, "min-height", "200px"], [3, "title"], [1, "table", "table-striped", "border-0", "table-fixed", "table-auto-lg"], [2, "cursor", "pointer", "user-select", "none"], ["data-test-id", "Column Headers"], [1, "colTxtMed", 3, "click", "ngClass"], [2, "padding-top", "0", "padding-bottom", "0"], [3, "click", "ngClass"], [1, "colTxtShort", 3, "click", "ngClass"], [1, "colTxtShort", "text-right", 3, "click", "ngClass"], [4, "ngFor", "ngForOf"], [4, "ngIf"], [1, "td-ellipsis"], [1, "td-ellipsis-content"], [1, "text-right"], ["href", "#", 1, "td-ellipsis-content"], [3, "textContent"], [3, "href", "text"], [1, "panel-footer", "panel-footer-short"], ["ycnDisabled", "", 1, "btn", "btn-secondary", 3, "click", "disabled"], ["loaderMessage", "Loading Data..."]], template: function HoldingsAllHoldingsComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3)(3, "div", 4);
        i0.ɵɵtext(4);
        i0.ɵɵtemplate(5, HoldingsAllHoldingsComponent_ycn_holdings_all_holdings_date_picker_5_Template, 1, 1, "ycn-holdings-all-holdings-date-picker", 5);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(6, "div", 6)(7, "div", 7)(8, "h3", 8);
        i0.ɵɵtext(9, "All Holdings\u00A0 ");
        i0.ɵɵelementStart(10, "span", 9);
        i0.ɵɵtext(11);
        i0.ɵɵelementStart(12, "span", 10);
        i0.ɵɵlistener("click", function HoldingsAllHoldingsComponent_Template_span_click_12_listener() { i0.ɵɵrestoreView(_r1); const helpModal_r4 = i0.ɵɵreference(38); return i0.ɵɵresetView(helpModal_r4.openModal("holdings_all_holdings_tab")); });
        i0.ɵɵtext(13, "(?)");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(14, "div", 11)(15, "div", 12)(16, "span", 13);
        i0.ɵɵtext(17);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(18, "div", 12)(19, "button", 14);
        i0.ɵɵlistener("click", function HoldingsAllHoldingsComponent_Template_button_click_19_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.pageChangeHandler(ctx.PAGE_CONTROLS.PREV)); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(20, "svg", 15);
        i0.ɵɵelementEnd()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(21, "div", 12)(22, "button", 16);
        i0.ɵɵlistener("click", function HoldingsAllHoldingsComponent_Template_button_click_22_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.pageChangeHandler(ctx.PAGE_CONTROLS.NEXT)); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(23, "svg", 15);
        i0.ɵɵelementEnd()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(24, "div", 17)(25, "ycn-cascading-dropdown", 18);
        i0.ɵɵlistener("handler", function HoldingsAllHoldingsComponent_Template_ycn_cascading_dropdown_handler_25_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.selectDropdownOption($event)); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵtemplate(26, HoldingsAllHoldingsComponent_div_26_Template, 25, 8, "div", 19)(27, HoldingsAllHoldingsComponent_div_27_Template, 11, 7, "div", 20)(28, HoldingsAllHoldingsComponent_ycn_loading_symbol_28_Template, 1, 0, "ycn-loading-symbol", 21);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(29, "ycn-modal-base", 22);
        i0.ɵɵlistener("closeModalHandler", function HoldingsAllHoldingsComponent_Template_ycn_modal_base_closeModalHandler_29_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementStart(30, "ycn-simple-modal-header", 23);
        i0.ɵɵlistener("closeModalHandler", function HoldingsAllHoldingsComponent_Template_ycn_simple_modal_header_closeModalHandler_30_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(31, "div", 24);
        i0.ɵɵelement(32, "div", 25);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "div", 26)(34, "div", 27)(35, "div", 28);
        i0.ɵɵlistener("click", function HoldingsAllHoldingsComponent_Template_div_click_35_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵtext(36, " Close ");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelement(37, "ycn-help-modal", null, 0);
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", ctx.displaySecurityId, " Holdings ");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.validHoldingDates);
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" As of ", ctx.asOfDate, " ");
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate3(" Showing ", ctx.paginationInfo.start_index, "-", ctx.paginationInfo.end_index, " of ", ctx.paginationInfo.num_items, " items ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", ctx.pageNum === 1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-back");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", ctx.pageNum === ctx.paginationInfo.num_pages);
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-collapse");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("showDropdownCaret", false)("config", ctx.actionsDropdownConfig);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading && ctx.USER.authenticated);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("extraModalClasses", "modal-sm")("open", ctx.showSaveAsWatchlistResult);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("textContent", ctx.saveAsWatchlistResult);
    } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i4.HoldingsAllHoldingsDatePickerComponent, i5.IconDirective, i6.DisabledDirective, i7.CascadingDropdownComponent, i8.HelpModalComponent, i9.LoadingSymbolComponent, i10.ModalBaseComponent, i11.SimpleModalHeaderComponent, i12.ModuleUpsellComponent], encapsulation: 2 });
